import { provideState } from '@ngrx/store';
import { APP_STORE } from '@ieCore/consts/store.consts';
import { userReducer } from '@ieApp/store/user/user.reducer';

export const appStates = [provideState(APP_STORE.USER, userReducer)];
